import { render } from "./GerirAtendimentoSecretaria.vue?vue&type=template&id=f12df24e&scoped=true"
import script from "./GerirAtendimentoSecretaria.vue?vue&type=script&lang=js"
export * from "./GerirAtendimentoSecretaria.vue?vue&type=script&lang=js"

import "./GerirAtendimentoSecretaria.vue?vue&type=style&index=0&id=f12df24e&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12df24e"]])

export default __exports__